import { render, staticRenderFns } from "./ModalClarification.vue?vue&type=template&id=86ec5ba2"
import script from "./ModalClarification.vue?vue&type=script&lang=js"
export * from "./ModalClarification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports